import { Dispatch } from 'redux';

import { Events } from 'src/constants/webSocketConsts/events';
import {
  CreditBalanceResponse,
  studioCreditApi,
} from 'src/services/api/studioCreditApi';

// The backend broadcasts the balance row's display subset (the same shape
// GET /credit-balance returns) on every grant/deduction, so we can patch the
// cache in place rather than refetch. updateQueryData is a no-op when the query
// isn't subscribed (user not on the Plans page), which is exactly what we want.
export function handleCreditBalanceUpdate(
  event: Events,
  items: CreditBalanceResponse[],
  dispatch: Dispatch<any>,
) {
  const balance = items.at(0);
  if (!balance) {
    return;
  }

  // The balance row is never deleted; INSERT (first grant) and MODIFY both
  // carry the current balance, so both simply overwrite the cached value.
  if (event !== Events.Insert && event !== Events.Modify) {
    return;
  }

  dispatch(
    studioCreditApi.util.updateQueryData(
      'getCreditBalance',
      undefined,
      () => balance,
    ),
  );
}
